import { render, staticRenderFns } from "./MyRequest.vue?vue&type=template&id=14b1c2f8"
import script from "./MyRequest.vue?vue&type=script&lang=js"
export * from "./MyRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports